import axios from "axios";
import ApiService from "@/services/ApiService.js";

export const state = {
  listDelitos:[],
  listAccionesEspecificas:[]
};
export const mutations = {
  GET_DELITOS({ context }, delitos) {
    let delitos_array = [];
    Object.entries(delitos).forEach(([key, val]) => delitos_array.push(val));
    return (state.listDelitos = delitos_array);
  },
  GET_ACCIONES_ESPECIFICAS({ context }, especificas) {
    let especificas_array = [];
    Object.entries(especificas).forEach(([key, val]) => especificas_array.push(val));
    return (state.listAccionesEspecificas = especificas_array);
  },
};
export const actions = {
  GET_DELITOS({ commit }, data) { //axios, mandar parametros para post
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.get(data)
        .then(response => {
          // console.log(response.data);
          commit("SET_LOADING", false);
          commit("GET_DELITOS", response.data.data.delitos);//mandar a mutations
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },

  GET_ACCIONES_ESPECIFICAS({ commit }, data) { //axios, mandar parametros para post
    // console.log(data);
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.get(data)
        .then(response => {
          // console.log(response.data);
          commit("SET_LOADING", false);
          commit("GET_ACCIONES_ESPECIFICAS", response.data.data.acciones_especificas);//mandar a mutations
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },

  GET_ACCIONES_SIMULTANEAS({ commit }, data) { //axios, mandar parametros para post
    // console.log(data);
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.get(data)
        .then(response => {
          commit("SET_LOADING", false);
          // commit("GET_ACCIONES_SIMULTANEAS", response.data.data.acciones_simultaneas);//mandar a mutations
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },

  SAVE_DELITO({ commit }, data) { //axios, mandar parametros para post
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.post(data)//funcion de ApiService
        .then(response => {
          commit("SET_LOADING", false);
          // commit("SAVE_DELITO", response);//mandar a mutations
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },

  EDIT_DELITO({ commit }, data) { //axios, mandar parametros para post
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.put(data)//funcion de ApiService
        .then(response => {
          commit("SET_LOADING", false);
          // commit("EDIT_DELITO", response);//mandar a mutations
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
      });
    },

    DELETE_DELITO({ commit }, id) { //axios, mandar parametros para post
      return new Promise((resolve, reject) => {
        commit("SET_LOADING", true);
        ApiService.delete(id)//funcion de ApiService
          .then(response => {
            //console.log("store",response);
            commit("SET_LOADING", false);
            resolve(response);
          })
          .catch(error => {
            commit("SET_LOADING", false);
            reject(error);
          });
      });
    },

};

export const getters = {//leer datos
  // listDelitos: state => state.listDelitos,
};
